import React from 'react';
import { Box, Typography, useTheme, alpha } from '@mui/material';

function VersionFooter() {
  const theme = useTheme();
  const version = process.env.REACT_APP_VERSION || '0.1.0';
  const buildDate = process.env.REACT_APP_BUILD_DATE || 'dev';
  const buildId = process.env.REACT_APP_BUILD_ID || 'local';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: 0.5,
        px: 2,
        bgcolor: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: 'blur(10px)',
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        zIndex: 1000,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '0.7rem',
        }}
      >
        v{version} • Build #{buildId} • {buildDate}
      </Typography>
    </Box>
  );
}

export default VersionFooter;
